import Button from './Button';
import './style/TextAreaModal.css';
import React, { useRef } from 'react';
import TextArea from './TextArea';
import { Text } from '@harperai/materialize-design-system';

const TextAreaModal = ({ cta, ctaLoading, inputLabel, inputPlaceholder, onSubmit }) => {
    const inputRef = useRef(null);

    const handleSendFeedback = () => {
        const inputValue = inputRef.current.value;
        console.log(inputValue);
        onSubmit(inputValue);
    };

    return (
        <div className="keystone-text-area-modal">
            <div className="pad-l no-pad-bot">
                <div className="product-horizontal-container mobile-vertical h-gap-m v-gap-m flex-1 justify-end">
                    <div className="product-vertical-container v-gap-xs flex-1">
                        <Text bold={true}>{inputLabel}</Text>
                        <TextArea placeholder={inputPlaceholder} type="text" inputRef={inputRef} large={true} onWhite={false} />
                    </div>
                </div>
            </div>
            <div className="modal-footer flex-1 justify-end pad-l h-gap-l">
                <div className="product-vertical-container">
                    <div className="product-horizontal-container h-gap-s">
                        <Button brand={true} label={cta} loading={ctaLoading} large="true" onClick={handleSendFeedback} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(TextAreaModal);